export const URL_REGEX =
  /(!]\()(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/g;

export const USERNAME_REGEX = /(@\w+)/g;

export const HASHTAG_REGEX = /(#\w+)/g;

export const EMOJI_REGEX = /:\w+:/gi;
